import { useEffect } from "react";

/**
 * Adds <meta name="robots" content="noindex"> for as long as the calling component is
 * mounted, removing it on unmount. For a React Router SPA, this is the per-route equivalent
 * of a static page's <meta> tag — there's no server-rendered head to vary per route, so this
 * is the only mechanism available. Currently only /join/:code needs this: it's a private
 * league's invite preview, thin duplicate content by nature (see docs/agents and the SEO
 * section of the growth plan) — never a page search engines should index.
 */
export function useNoIndex(): void {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}
